export default "__VITE_ASSET__89aabd63__"